import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import whiteLogo from '../images/whiteLogo.png';
import couchTexture from '../images/Home-1.png';

import css from './SectionAnimationMobile.module.css';

const SectionAnimationMobile = props => {
    const { rootClassName, className } = props;

    const classes = classNames(rootClassName || css.root, className);
    return (
        <div className={classes}>
            <img src={couchTexture} className={css.animationCouchTexture} />

            <div className={css.container}>
                <div className={css.top} />
                <div className={css.center}>
                    <div className={css.dummyHeroImageWrapper}>
                        <div className={css.dummyGatePic} />
                        <img src={whiteLogo} className={css.animationWhiteLogo} />
                    </div>
                </div>
                <div className={css.bottom} />
            </div>
        </div>
    );
};

SectionAnimationMobile.defaultProps = {
    rootClassName: null,
    className: null
};

const { string } = PropTypes;

SectionAnimationMobile.propTypes = {
    rootClassName: string,
    className: string,
};

export default SectionAnimationMobile;